"use client";

import { c as _c } from "react/compiler-runtime";
import React from "react";
import { useSearchParams } from "next/navigation";
import MyStreamWave from "../brain/my-stream/MyStreamWave";
import BrainContent from "../brain/content/BrainContent";
import PrimaryButton from "../utils/button/PrimaryButton";
import { faPaperPlane } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import CreateDirectMessageModal from "../waves/create-dm/CreateDirectMessageModal";
import { useAuth } from "../auth/Auth";
import useDeviceInfo from "../../hooks/useDeviceInfo";
import useCreateModalState from "@/hooks/useCreateModalState";
const MessagesView: React.FC = () => {
  const $ = _c(20);
  const searchParams = useSearchParams();
  const {
    connectedProfile
  } = useAuth();
  const {
    isApp
  } = useDeviceInfo();
  const {
    isDirectMessageModalOpen,
    openDirectMessage,
    close
  } = useCreateModalState();
  let t0;
  if ($[0] !== searchParams) {
    t0 = searchParams?.get("wave") || null;
    $[0] = searchParams;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const serialisedWaveId = t0;
  const showPlaceholder = !serialisedWaveId && !isApp;
  let content = null;
  if (serialisedWaveId) {
    const t1 = `dm-wave-${serialisedWaveId}`;
    let t2;
    if ($[2] !== serialisedWaveId || $[3] !== t1) {
      t2 = <MyStreamWave key={t1} waveId={serialisedWaveId} />;
      $[2] = serialisedWaveId;
      $[3] = t1;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    content = t2;
  } else {
    if (showPlaceholder) {
      let t1;
      let t2;
      if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = <h2 className="tw-text-xl tw-font-bold tw-text-iron-50 tw-mb-4">Select a Conversation</h2>;
        t2 = <p className="tw-text-iron-400 tw-max-w-md tw-mb-6">Choose a direct message conversation from the sidebar to view messages and continue the discussion.</p>;
        $[5] = t1;
        $[6] = t2;
      } else {
        t1 = $[5];
        t2 = $[6];
      }
      let t3;
      let t4;
      if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = <FontAwesomeIcon icon={faPaperPlane} className="tw-size-4 tw-flex-shrink-0 tw-mr-2" />;
        t4 = <span>Create DM</span>;
        $[7] = t3;
        $[8] = t4;
      } else {
        t3 = $[7];
        t4 = $[8];
      }
      let t5;
      if ($[9] !== openDirectMessage) {
        t5 = <div className="tw-flex tw-flex-col tw-items-center tw-justify-center tw-h-full tw-text-center tw-p-8">{t1}{t2}<PrimaryButton onClicked={openDirectMessage} loading={false} disabled={false}>{t3}{t4}</PrimaryButton></div>;
        $[9] = openDirectMessage;
        $[10] = t5;
      } else {
        t5 = $[10];
      }
      content = t5;
    }
  }
  let t1;
  if ($[11] !== content) {
    t1 = <BrainContent activeDrop={null} onCancelReplyQuote={_temp}>{content}</BrainContent>;
    $[11] = content;
    $[12] = t1;
  } else {
    t1 = $[12];
  }
  let t2;
  if ($[13] !== close || $[14] !== connectedProfile || $[15] !== isDirectMessageModalOpen) {
    t2 = connectedProfile && <CreateDirectMessageModal isOpen={isDirectMessageModalOpen} onClose={close} profile={connectedProfile} />;
    $[13] = close;
    $[14] = connectedProfile;
    $[15] = isDirectMessageModalOpen;
    $[16] = t2;
  } else {
    t2 = $[16];
  }
  let t3;
  if ($[17] !== t1 || $[18] !== t2) {
    t3 = <>{t1}{t2}</>;
    $[17] = t1;
    $[18] = t2;
    $[19] = t3;
  } else {
    t3 = $[19];
  }
  return t3;
};
export default React.memo(MessagesView);
function _temp() {}